module.exports = __webpack_public_path__ + "img/mytd1.1641520899224.png";